<template>
  <grid
    ref="grid"
    :data="displayData"
    :loading="loading"
    :options="options"
    @change-filter="changeFilter"
    @radio-change="onRadioChange"
  />
</template>

<script>
import EditLoading from '@/mixins/edit-loading'
import {
  applyTableFilters,
  buildFilterOptions,
  resetTableFilters,
} from '../table-filter-helpers'
import Grid from './grid.vue'

export default {
  components: { Grid },
  mixins: [EditLoading],
  props: {
    shipmentCode: { type: String, default: '' },
    shipmentContainerCode: { type: String, default: '' },
  },
  data() {
    return {
      loading: false,
      tableData: [],
      currentRow: null,
      filters: {
        bookingTypeName: [],
        dispatchPortName: [],
        destinationPortName: [],
        destinationPortFullName: [],
        destinationCountry: [],
        shipmentTypeName: [],
        quotedMethodName: [],
        deliveryDate: [],
        eta: [],
        fbaArrivalDate: [],
        bookingScmName: [],
        customsBrokerScmName: [],
        domesticTransitName: [],
        overseasTransitName: [],
        shipperName: [],
        consigneeName: [],
        notifierName: [],
        shipVoyage: [],
        bookingDate: [],
      },
    }
  },
  computed: {
    options() {
      return buildFilterOptions(this.tableData, Object.keys(this.filters))
    },
    displayData() {
      return applyTableFilters(this.tableData, this.filters, this.options)
    },
  },
  watch: {
    shipmentCode() {
      this.clearCurrentRow()
      this.getData()
    },
    shipmentContainerCode() {
      this.clearCurrentRow()
    },
    tableData() {
      this.resetFilters()
    },
    displayData(val) {
      const shipmentBookingCode =
        this.currentRow && this.currentRow.shipmentBookingCode
      if (
        shipmentBookingCode &&
        !val.some((row) => row.shipmentBookingCode === shipmentBookingCode)
      ) {
        this.clearCurrentRow()
      }
    },
  },
  mounted() {
    this.getData()
  },
  methods: {
    changeFilter({ field, value }) {
      this.filters[field] = value
    },
    async getData() {
      if (!this.shipmentCode) {
        this.clearCurrentRow()
        this.tableData = []
        return
      }

      this.loading = true
      const res = await this.$api
        .ecomShipmentBookingListApi({
          shipmentCode: this.shipmentCode,
        })
        .catch(() => null)
      this.loading = false
      if (!res) return

      this.tableData = res.body?.data || []
    },
    resetFilters() {
      this.filters = resetTableFilters(this.filters)
    },
    onRadioChange({ newValue }) {
      this.currentRow = newValue || null
    },
    clearCurrentRow() {
      this.currentRow = null
      this.$nextTick(() => {
        const grid = this.$refs.grid
        if (grid) grid.clearRadioRow()
      })
    },
    async save() {
      const shipmentBookingCode =
        this.currentRow && this.currentRow.shipmentBookingCode
      if (!shipmentBookingCode) {
        this.$message.warning(
          this.$l('tips_select_booking') || '请先选择订舱记录'
        )
        return
      }
      if (!this.shipmentContainerCode) return

      if (this.loadingOpen()) return
      const res = await this.$api
        .ecomShipmentBookingAppendApi({
          shipmentBookingCode,
          listShipmentContainerCode: [this.shipmentContainerCode],
        })
        .catch(() => null)
      this.loadingClose()
      if (!res) return

      const { status, msg } = res
      const error = status !== 200

      this.$message({
        showClose: true,
        message: msg,
        type: error ? 'error' : 'success',
      })
      if (error) return

      this.$emit('reload')
      this.$emit('close')
    },
    cancel() {
      this.$emit('close')
    },
  },
}
</script>
